import { render, staticRenderFns } from "./BolsaTrabajoMain.vue?vue&type=template&id=604b55d4&scoped=true&"
import script from "./BolsaTrabajoMain.vue?vue&type=script&lang=js&"
export * from "./BolsaTrabajoMain.vue?vue&type=script&lang=js&"
import style0 from "./BolsaTrabajoMain.vue?vue&type=style&index=0&id=604b55d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604b55d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VCol,VIcon,VRow,VSelect,VSkeletonLoader})
